<template>
  <div class="event-times row">
    <div class="col-12 element">
      <label>Start & End Time</label>
    </div>
    <div v-if="times.length > 1" class="col-12 mb-3">
      <Field
        type="checkbox"
        id="cb_use_same_time"
        name="use_same_time"
        label="Use the same start & end time for each day of the event"
        v-model="sameTime"
        :checkbox-value="1"
      />
    </div>
    <template v-for="(time, i) in times">
      <div v-if="!sameTime || i === 0" :key="i" class="event-time col-12">
        <div v-if="times.length > 1" class="day-tag">Day {{ i + 1 }}</div>
        <TimeField :name="`times[${i}][start_time]`" :value="time.start_time" />
        <div class="separator">to</div>
        <TimeField :name="`times[${i}][end_time]`" :value="time.end_time" />
        <input type="hidden" :name="`times[${i}][order]`" :value="i + 1" />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Array, default: () => [] },
  },
  data() {
    return {
      times: [],
      sameTime: false,
    };
  },
  watch: {
    times(val) {
      this.$emit("input", val);
    },
  },
  created() {
    this.times = this.value;
  },
};
</script>